import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Seo from "./Seo";
import Sidebar from "./Sidebar";

/**
 * Estructura común a todas las páginas.
 *
 * fullBleed: la página maneja su propio ancho (la home, que alterna franjas de
 * color a todo lo ancho). El resto entra en el canal de `.shell`.
 */
const Layout = ({ children, fullBleed = false, hasSidebar = false }) => (
	<div className="flex min-h-screen flex-col bg-white">
		<Seo />
		<Header />

		<main id="contenido" className="flex-1">
			{
				fullBleed
					? children
					: (
						<div className="shell py-10 lg:py-14">
							{
								hasSidebar
									? (
										<div className="flex flex-col gap-8 md:flex-row lg:gap-12">
											<Sidebar />
											<div className="min-w-0 flex-1">{ children }</div>
										</div>
									)
									: children
							}
						</div>
					)
			}
		</main>

		<Footer />
	</div>
);

export default Layout;
